import { render, staticRenderFns } from "./Repo.vue?vue&type=template&id=a7c00020&"
import script from "./Repo.vue?vue&type=script&lang=js&"
export * from "./Repo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports